import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';

import type { DeleteOrganizationLetterheadsMutation, DeleteOrganizationLetterheadsMutationVariables } from '@/graphql/generated/graphql';
import { DeleteOrganizationLetterheadsDocument } from '@/graphql/generated/graphql';
export type DeleteOrganizationLetterheadInput = {
  ItemId: string
  isHardDelete?: boolean
}

export type DeleteOrganizationLetterheadResponse = {
  data: {
    deleteOrganizationLetterheads: {
      itemId: string
      totalImpactedData: number
      acknowledged: boolean
      message?: string | null
    }
  }
}

export const useDeleteOrganizationLetterhead = () => {
  const mutation = useMutation({
    mutationKey: ['delete-organization-letterhead'],
    mutationFn: ({ ItemId, isHardDelete = false }: DeleteOrganizationLetterheadInput) => {
      return graphqlClient.request<DeleteOrganizationLetterheadsMutation>(DeleteOrganizationLetterheadsDocument,
        { ItemId, isHardDelete }
      )
    }
  })

  return {
    ...mutation,
    deleteOrganizationLetterhead: mutation.mutate,
    deleteOrganizationLetterheadAsync: mutation.mutateAsync,
  }
}

export const DELETE_ORGANIZATION_LETTERHEAD_MUTATION = DeleteOrganizationLetterheadsDocument;
